export default "__VITE_ASSET__CA_Sgdfd__"